import { connect } from "react-redux";
import storage from "app/services/storage";
import informationModule from "app/store/information";
import cinemasModule from "app/store/cinemas";
import CinemaDetails from "./CinemaDetails.component";
import layout from "app/store/layout";

const {
  requestCinema,
  requestDates,
  requestMovieSessions,
  requestMovieOperaSessions,
  setCinema,
  setDates,
  setMovieSessions,
  cinemaExtraInfoGet
} = cinemasModule.actions;

const { setLoader } = layout.actions;

const {
  priceListContentRequest,
  priceListGastronomyContentRequest,
  hallTicketRequest,
  setPriceListContent
} = informationModule.actions;

const mapDispatchToProps = {
  fetchCinema: requestCinema,
  fetchDates: requestDates,
  fetchMovieSessions: requestMovieSessions,
  fetchMovieOperaSessions: requestMovieOperaSessions,
  fetchContent: priceListContentRequest,
  fetchContentGastronomy: priceListGastronomyContentRequest,
  fetchExtraInfo: cinemaExtraInfoGet,
  getHallTicketdetails: hallTicketRequest,
  setCinema,
  setDates,
  setMovieSessions,
  setLoaderData: setLoader,
  setContent: setPriceListContent
};

const mapStateToProps = ({ information, cinemas, user, layout }) => ({
  cinemaDetails: cinemas.cinema,
  movies: cinemas.sessions,
  dates: cinemas.dates,
  savedLocation: storage.getLocation(),
  isLoggedIn: !!user.user,
  locations: layout.locations,
  content: information.priceListContent,
  extraInfo: cinemas.extraInfo,
  hallTicketDetails: information.hallTicket,
  gastronomyContent: information.priceListContentGastronomy,
  legalInfo: information.legalInfoContent.slice().reverse()
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CinemaDetails);
